function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{display:none;}\n\t.st1{fill:none;stroke:#BBC0CF;stroke-width:2;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M26.6,17.9c0,0-1.6-0.2-3.3,1.4c-1.2,1.1-1.5,2.5-1.5,2.5l-0.2,4.2c-0.3,2-2.6,2.2-2.6,2.2 c-3,0-3.1-2.4-3.1-2.4v-6.9l0-3.2l-5.3,0.1v4.9c0,5.8,0,5.9,0.1,6.3l0,0v0c0.2,1,0.6,2,1.1,2.7h0c1,1.7,2.7,3,4.5,3.6 c0.8,0.3,1.4,0.4,2.2,0.4c3.6,0.2,7-2.1,8.2-5.5c0.3-0.8,0.4-1.4,0.4-2.6l0-1.1l0-1l1,0l2.8,0l1.7,0l0-5.4L26.6,17.9z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 8.2,
  y: 12,
  className: "st1",
  width: 9.9,
  height: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 32.7,
  y: 15.7,
  className: "st1",
  width: 3.5,
  height: 9.9
}));

function SvgPlumbingAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 1378,
    height: 1112,
    xlinkHref: "../../Screen Shot 2022-12-05 at 12.30.14 PM.png",
    transform: "matrix(2.503341e-02 0 0 2.503341e-02 5.6667 9.1231)"
  })), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbingAlt);
export default __webpack_public_path__ + "static/media/PlumbingAlt.b5d30337.svg";
export { ForwardRef as ReactComponent };